// The Vue build version to load with the `import` command
import Vue from 'vue';
import App from './App';
import router from './router'
import VueRouter from 'vue-router';
// import routers from './router/index.js';

import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'

import store from './store/index.js';
import index from "./App.vue";  //初始化路由登录页
import ajax from "./libs/js/vueExtend/ajax.js";
import routePlugin from "./libs/js/vueExtend/routePlugin.js";
import loadingView from "./libs/js/vueExtend/loadingView.js";
import publicjs from './libs/js/public.js'; //公共函数挂载
import log from "./libs/js/vueExtend/log.js";
import eventBus from "./libs/js/vueExtend/eventBus.js";
import scoped from "./libs/js/vueExtend/directive/scoped.js";
import webSocket from './libs/js/vueExtend/webSocket';

import $localStorage from "./libs/js/localStorage.js";
import cookie from "./libs/js/cookie.js";

import dealFunction from "./libs/js/deal_function.js";

const devMode = process.env.NODE_ENV === "development"; //是否开发模式









// import 'lib-flexible'
// 引入iview框架
import iView from 'iview';
import 'iview/dist/styles/iview.css';    // 使用 CSS
Vue.use(iView);
// 引入elementui 框架
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

import qs from 'qs'; //用于拦截OPTIONS的请求

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import axios from 'axios'
Vue.prototype.$http = axios;

// 全局的配置的默认值/defaults
export let axios_config = () => {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';    
    axios.defaults.timeout = 600000;
}

axios_config();
Vue.prototype.$qs = qs;  //
Vue.prototype.$bus = new Vue();  //找到你要调用的那个地方

//全局css
import './assets/css/mian_base.less'
import './assets/css/animate.css'
import '../static/font_icon/iconfont.css'  //iconfont字体库

Vue.use(VueAwesomeSwiper);
Vue.use(VueRouter);
Vue.use(ajax);
Vue.use(scoped);
Vue.use(routePlugin);
Vue.use(loadingView);
Vue.use(eventBus);
Vue.use(webSocket);
Vue.use(log); //输出console；生产环境会自动屏蔽
Vue.use(localStorage); //localStorage加密存储
Vue.use(dealFunction);  //处理函数
Vue.use(cookie);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;

var logintoken = false;
// 添加请求拦截器
axios.interceptors.request.use(function(config) {
    //添加token
    let token = $localStorage.getStore('info');

    if(config.method  === 'post'||config.method  === 'get'){   //格式化参数
      config.data = qs.stringify(config.data);
    }
    if (config.url.indexOf('/auth/login') !== -1 || config.url.indexOf('/auth/creat') !== -1) {
      config.headers['Authorization'] = 'Basic bW9uaXRvcjk1NmE3ZjVjZjYxNmE4ZDc3YjoxMjM0NTY='
      // console.log('配置-=-=-=X-baseURL' + JSON.stringify(config.headers))

      return config
    }

    // do something before request is sent
    if (token) {
      config.headers['Authorization'] = token
    }
    return config;
}, function(error) {
   
    // 对请求错误做些什么
    return Promise.reject(error);
});
// // 拦截返回的数据
axios.interceptors.response.use(response => {
  return response
}, error => {
  if(error.response.status==401){
    console.log('没有数据权限401')
    updateSign_out()
  }
  return Promise.reject(error)
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
    // console.log("检测是否登录的页面"+to.name)
    console.log("全局路由守卫-=-=-=-=-=-"+JSON.stringify(to.name))
    const nextRoute = ['index','MonitorSeats'] // 需要登录的页面
    // let isLogin = $localStorage.getStore('login_info');  // 判断是否登录，本地存储有用户数据则视为已经登录
    let isLogin = $localStorage.getStore('info');
    let login_status =$localStorage.getStore('loginStatus');
    // console.log("检测是否登录的页面"+to.name+"info"+isLogin+"status"+login_status)
    // 未登录状态；当路由到 nextRoute 指定页时，跳转至 UserLogIn
    if (nextRoute.indexOf(to.name) >= 0) { // 检测是否登录的页面

        if (!isLogin&&!login_status) { // 如果未登录（本地存储无用户数据），并且要跳到登录页面

            if (from.name === 'login') {
                next('/');
                return
            }
        // 登录后，跳到到当前页面
        router.replace({
          name: 'login',
          params: {redirect: to.fullPath}
        })
      }
    }
    // 已登录状态；当路由到 UserLogIn 时，跳转至 Home
    if (to.name === 'login') {
      console.log("已登录状态-=-=-=-=-=-")

      if (isLogin&&login_status==1) {
          next('/index');
        return
      } else if(isLogin&&login_status==2){
        // window.location.replace("http://minpin.bjgas95.com/");

      }
    }
    next() // 必须使用 next ,执行效果依赖 next 方法的调用参数
  });


  Vue.config.productionTip = false

  /* eslint-disable no-new */
  const mainVue = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  });
global.Vue = mainVue;

export default mainVue;



// WEBPACK FOOTER //
// ./src/main.js